@if (attribute) {
  <div [class.invisible]="isLoading"
       [ngClass]="{'invalid-list': hasError}"
       class="d-flex justify-content-between list-header align-items-center">
    <app-field-label [attribute]="attribute"
                     [passportId]="passportId"></app-field-label>
    <ix-button (click)="addListItem()" icon="add-circle"
               [id]="'editPassportAddButton_' + fullValuePath"
               onkeyPress=""
               variant="subtle-tertiary">Add
    </ix-button>
  </div>
  @if (hasError) {
    <ix-typography format="label" textColor="alarm">{{ createInvalidText(control) }}</ix-typography>
  }
  <ix-layout-grid class="pe-0 ps-0">
    @if (!passData || (Array.isArray(passData) && passData.length === 0)) {
      <ix-row class="d-flex justify-content-center">
        <ix-col class="text-center" size="12">
          <ix-empty-state
            (actionClick)="addListItem()"
            header="{{'battery_pass.edit.empty_list.attribute_header' | translate}}"
            layout="compact"
            subHeader="{{'battery_pass.edit.empty_list.attribute_subheader' | translate}}"
          ></ix-empty-state>
        </ix-col>
      </ix-row>
    }
    @if (passData && Array.isArray(passData) && passData.length > 0) {
      @for (pass of passData; track pass; let i = $index) {
        <ix-row class="expandable-row">
          <ng-container>
            <ix-icon-button (click)="removeItem(i)" icon="trashcan"
                            onkeyPress="" variant="subtle-primary"></ix-icon-button>
            <ix-col class="p-0 border-left">
              @for (listAttribute of attribute.attributes; track listAttribute.valuePath) {
                <ix-row>
                  <ix-col class="pt-1" size="12">
                    @if (attribute.type === 'list:language' && isLanguageColumn(listAttribute.valuePath)) {
                      <app-language-select-input
                        [attribute]="attribute"
                        [passportId]="passportId"
                        [fullValuePath]="fullValuePath"
                        [saveFunction]="saveFunction"
                        [passData]="passData"
                        [row]="i"
                      />
                    } @else {
                      @switch (listAttribute.type) {
                        @case ('text') {
                          <app-text-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('number') {
                          <app-number-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('select') {
                          <app-select-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('date') {
                          <app-date-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('document') {
                          <app-document-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('url') {
                          <app-document-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('list:document') {
                          <app-document-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('email') {
                          <app-email-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('address') {
                          <app-address-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('boolean') {
                          <app-boolean-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('language') {
                          <app-language-text-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('list:text') {
                          <app-input-list-text
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('list') {
                          <app-input-list
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('list:language') {
                          <app-input-list
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('chart:pie') {
                          <app-input-list
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('chart:bar') {
                          <app-input-list
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('chart:line') {
                          <app-input-list
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('detail') {
                          <app-input-list
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('name-id') {
                          <app-name-id-input
                            [attribute]="listAttribute"
                            [passportId]="passportId"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @case ('imagePicker') {
                          <app-image-input
                            [attribute]="listAttribute"
                            [images]="listAttribute.data?.images ?? []"
                            [fullValuePath]="`${fullValuePath}[${i}].${listAttribute.valuePath}`"
                            [saveFunction]="saveFunction"
                            [passportId]="passportId"
                            [passData]="getData(`[${i}].${listAttribute.valuePath}`)"
                          />
                        }
                        @default {
                          <ix-message-bar
                            [persistent]="true"
                            type="warning"
                          >
                            {{ 'battery_pass.edit.component_not_found' | translate: {type: listAttribute.type} }}
                          </ix-message-bar>
                        }
                      }
                    }
                  </ix-col>
                </ix-row>
              }
            </ix-col>
          </ng-container>
        </ix-row>
      }
    }
  </ix-layout-grid>
}
<ix-spinner [class.d-none]="!isLoading"></ix-spinner>
